import { TrackedPhoneLink } from '../ui/TrackedPhoneLink';

interface NAPData {
  name: string;
  address: {
    street: string;
    city: string;
    state: string;
    zip: string;
    full: string;
  };
  phone: {
    display: string;
    tel: string;
  };
  email: string;
}

export const napData: NAPData = {
  name: "XXL IT Services",
  address: {
    street: "1624 E Territory Dr",
    city: "Meridian",
    state: "ID",
    zip: "83646",
    full: "1624 E Territory Dr, Meridian, ID 83646"
  },
  phone: {
    display: "(208) 328-4500",
    tel: "+12083284500"
  },
  email: "info@xxlservices.com"
};

interface NAPDisplayProps {
  variant?: 'full' | 'compact' | 'footer';
  showEmail?: boolean;
  className?: string;
}

export function NAPDisplay({ 
  variant = 'full', 
  showEmail = true, 
  className = "" 
}: NAPDisplayProps) {
  if (variant === 'compact') {
    return (
      <div className={`text-sm ${className}`}>
        <p className="font-semibold">{napData.name}</p>
        <p>{napData.address.full}</p>
        <TrackedPhoneLink
          location="nap_compact"
          className="text-primary-600 hover:text-primary-700 transition-colors"
        >
          {napData.phone.display}
        </TrackedPhoneLink>
      </div>
    );
  }

  if (variant === 'footer') {
    return (
      <div className={className}>
        <h3 className="text-xl font-bold mb-4">{napData.name}</h3>
        <address className="not-italic space-y-2">
          <p>{napData.address.street}</p>
          <p>{napData.address.city}, {napData.address.state} {napData.address.zip}</p>
          <p>
            <TrackedPhoneLink
              location="footer"
              className="hover:text-primary-400 transition-colors"
            >
              {napData.phone.display}
            </TrackedPhoneLink>
          </p>
          {showEmail && (
            <p>
              <a 
                href={`mailto:${napData.email}`}
                className="hover:text-primary-400 transition-colors"
              >
                {napData.email}
              </a>
            </p>
          )}
        </address>
      </div>
    );
  }

  return (
    <div className={className}>
      <h3 className="text-lg font-semibold mb-3">{napData.name}</h3>
      <address className="not-italic space-y-2">
        <p>{napData.address.street}</p>
        <p>{napData.address.city}, {napData.address.state} {napData.address.zip}</p>
        <p>
          <TrackedPhoneLink
            location="nap_full"
            className="text-primary-600 hover:text-primary-700 transition-colors"
          >
            {napData.phone.display}
          </TrackedPhoneLink>
        </p>
        {showEmail && (
          <p>
            <a 
              href={`mailto:${napData.email}`}
              className="text-primary-600 hover:text-primary-700 transition-colors"
            >
              {napData.email}
            </a>
          </p>
        )}
      </address>
    </div>
  );
}

// Hook for consistent NAP data access
export function useNAPData() {
  return napData;
}